module.exports = __webpack_public_path__ + "images/emoji/bathtub.6dda498537c0cbe9102e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bathtub.png
// module id = SJ8u
// module chunks = 13